import { Routes, Route } from "react-router-dom";
import Layout from "./ui/Layout.jsx";
import { useAnalytics } from "./lib/analytics.js";
import Home from "./pages/Home.jsx";
import Calculadoras from "./pages/Calculadoras.jsx";
import Guias from "./pages/Guias.jsx";
import Sobre from "./pages/Sobre.jsx";
import Privacidade from "./pages/Privacidade.jsx";
import Termos from "./pages/Termos.jsx";
import NotFound from "./pages/NotFound.jsx";

import SalarioCalc from "./calculators/SalarioCalc.jsx";
import DattaiCalc from "./calculators/DattaiCalc.jsx";
import RemessasCalc from "./calculators/RemessasCalc.jsx";

import ValeAPenaVoltar from "./guides/ValeAPenaVoltar.jsx";
import KakuteiShinkoku from "./guides/KakuteiShinkoku.jsx";
import GaimenKirikae from "./guides/GaimenKirikae.jsx";
import ShakaiVsKokumin from "./guides/ShakaiVsKokumin.jsx";
import RemessasGuide from "./guides/RemessasGuide.jsx";
import QuantoGanhaOperario from "./guides/QuantoGanhaOperario.jsx";
import RenovacaoVisto from "./guides/RenovacaoVisto.jsx";
import TrazerFamilia from "./guides/TrazerFamilia.jsx";
import AbrirContaBanco from "./guides/AbrirContaBanco.jsx";
import EncontrarMoradia from "./guides/EncontrarMoradia.jsx";
import HakkenVsSeishain from "./guides/HakkenVsSeishain.jsx";
import Glossario from "./guides/Glossario.jsx";
import TiposDeVisto from "./guides/TiposDeVisto.jsx";

export default function App() {
  useAnalytics();
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/calculadoras" element={<Calculadoras />} />
        <Route path="/calculadoras/salario" element={<SalarioCalc />} />
        <Route path="/calculadoras/aposentadoria" element={<DattaiCalc />} />
        <Route path="/calculadoras/remessas" element={<RemessasCalc />} />
        <Route path="/guias" element={<Guias />} />
        <Route path="/guias/vale-a-pena-voltar" element={<ValeAPenaVoltar />} />
        <Route path="/guias/kakutei-shinkoku" element={<KakuteiShinkoku />} />
        <Route path="/guias/gaimen-kirikae" element={<GaimenKirikae />} />
        <Route path="/guias/shakai-vs-kokumin" element={<ShakaiVsKokumin />} />
        <Route path="/guias/mandar-dinheiro-para-o-brasil" element={<RemessasGuide />} />
        <Route path="/guias/quanto-ganha-operario-japao-2026" element={<QuantoGanhaOperario />} />
        <Route path="/guias/renovacao-visto-zairyu-card" element={<RenovacaoVisto />} />
        <Route path="/guias/trazer-familia-para-o-japao" element={<TrazerFamilia />} />
        <Route path="/guias/abrir-conta-banco-japao" element={<AbrirContaBanco />} />
        <Route path="/guias/encontrar-moradia-apato-japao" element={<EncontrarMoradia />} />
        <Route path="/guias/hakken-vs-seishain" element={<HakkenVsSeishain />} />
        <Route path="/guias/glossario-japones-portugues" element={<Glossario />} />
        <Route path="/guias/trabalhar-legal-japao-tipos-de-visto" element={<TiposDeVisto />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/termos" element={<Termos />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
